import { styled } from '@mui/system';
import { Alert, Typography } from '@mui/material';

export const StyledAlert = styled(Alert)(({ theme }) => ({
  marginBottom: theme.spacing(3)
}));

export const InstructionText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));
